import styles from "./City.module.scss"
import GoBack from "../../../subsidiary/GoBack/GoBack";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchContest, fetchContests} from "../../NewYearEvent/eventSlice";
import {Loader} from "../Loader/Loader";
import {useNavigate} from "react-router-dom";

const City = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const contestID = useSelector(state => state.eventSlice.contestId)
    const contest = useSelector(state => state.eventSlice.contests)
    const token = useSelector(state => state.loginSlice.token)

    console.log(contest)
    console.log(contestID)
    useEffect(() => {
        dispatch(fetchContests({token}))
        if (contestID) {
            dispatch(fetchContest({token, contest: contestID}))
        }
    }, [dispatch, contestID])

    useEffect(() => {


    }, [])
    return (
        <section className='main'>
            <div className='content-wrapper'>
                <GoBack nav={`/contest/${contestID}`} text='Новогодний конкурс'/>
                <h1 className='apply_title'>
                    Город назначен!
                </h1>

                <p className={styles.conditionDescription}>
                    Ваша команда записывает поздравление
                    сотрудникам из города
                </p>
                <span className={styles.cityName}>{contest?.user_team?.purpose.name}</span>
                <div className={styles.btnContainer}>
                    <button
                        onClick={() => navigate('/video')}
                        className={styles.teamBtn}
                    >
                        Загрузить видео
                    </button>
                </div>
            </div>
        </section>

    )
}

export {City}